import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useGridSize from "../../hooks/useGridSize";
import { PortableText } from "@portabletext/react";


import styles from "./InfoPage.module.scss";

const InfoPage = () => {
  const PROJECT_ID = "spalbdrt";
  const DATASET = "production";
  const GROQ_QUERY = `*[_type == 'infoPage']{
  _id,
  icons[]->{
    slug,
    project->{title}
  },
  bioText->{
      bio,
      cv
    }
}`;
  const URL = `https://${PROJECT_ID}.api.sanity.io/v2024-04-09/data/query/${DATASET}?query=${encodeURIComponent(
    GROQ_QUERY
  )}`;

  const gridSize = useGridSize();

  const [infoData, setInfoData] = useState(null);
  // console.log((gridSize * 6 + 0.24 * gridSize + gridSize - 80)/1200);


   useEffect(() => {
     fetch(URL)
       .then((res) => res.json())
       .then(({ result }) => {
        // console.log(result[0])
        setInfoData(result[0]);
       })
       .catch((err) => console.error(err));
   }, [URL]);

  return (
    <main
      className={styles.main}
      style={{
        backgroundSize: gridSize + "px " + gridSize + "px",
        fontSize: (gridSize * 6 + 0.24 * gridSize + gridSize) / 16 + "%",
      }}
    >
      <div
        className={`${styles.note} ${styles.headerLink}`}
        style={{
          // top: 0 * gridSize + 0.06 * gridSize + 20,
          top: 0,
          left: 1 * gridSize + 0.06 * gridSize + 20,
          width: gridSize * 0.76,
          paddingLeft: 0.06 * gridSize,
          paddingRight: 0.06 * gridSize,
        }}
      >
        <Link to="/">Daniel Dmyszewicz</Link>
      </div>
      <div
        className={styles.infoContainer}
        style={{
          // width: gridSize * 7 - 0.24 * gridSize - 40,
          // height: gridSize * 4 - 60,
          // top: gridSize * 0.88 + 20 - 0.5 * gridSize,
          // left: gridSize * 0.88 + 20 - 0.5 * gridSize,
        }}
      >
        {infoData && (
          <>
            <div className={styles.indexColumn}>
              <div>
                <ul className={styles.projectsList}>
                  <span className={styles.indexTitle}>Index</span>
                  <br></br>
                  <br></br>
                  {infoData.icons.map((project, i) => (
                    <li key={i}>
                      <Link to={"/" + project.slug}>
                        {project.project.title}
                      </Link>
                    </li>
                  ))}
                </ul>
                <br></br>
                <PortableText value={[...infoData.bioText.bio]} />
              </div>
              <p>
                Copyright D. Dmyszewicz 2025 <br></br>
                Website by Vladyslav Omelianenko
              </p>
            </div>
            <div className={styles.columnBreak}></div>
            <div className={styles.bioText}>
              <PortableText
                value={[...infoData.bioText.cv]}
                components={{
                  block: { normal: ({ children }) => <p>{children}</p> },
                }}
              />
            </div>
          </>
        )}
      </div>
    </main>
  );
}

export default InfoPage;